import { axios } from '@/services/axios';

const getVoicePolicy = (voicePolicyId) => {
    return axios.get(`/VoicePolicy/${voicePolicyId}`);
};

export default getVoicePolicy;
